'use client';

import type { CommunityPost } from '@/lib/community/types';
import { PostCardSkill } from './post-card-skill';
import { PostCardTool } from './post-card-tool';
import { PostCardWorkflow } from './post-card-workflow';
import { PostCardAgent } from './post-card-agent';
import { PostCardAgentTeam } from './post-card-agent-team';
import { PostCardDiscussion } from './post-card-discussion';

export type PostCardProps = {
	post: CommunityPost;
	onClick?: (post: CommunityPost, rect: DOMRect, coverRect?: DOMRect) => void;
	onTagClick?: (tag: string) => void;
	onLike?: (post: CommunityPost) => Promise<void>;
	onFavorite?: (post: CommunityPost) => Promise<void>;
};

/**
 * PostCard — polymorphic dispatcher.
 * Switches on `post.abilityType` and renders the matching card variant.
 */
export function PostCard({ post, onClick, onTagClick, onLike, onFavorite }: PostCardProps) {
	const props = { post, onClick, onTagClick, onLike, onFavorite };

	switch (post.abilityType) {
		case 'skill':
			return <PostCardSkill {...props} />;
		case 'tool':
			return <PostCardTool {...props} />;
		case 'workflow':
			return <PostCardWorkflow {...props} />;
		case 'agent':
			return <PostCardAgent {...props} />;
		case 'agent-team':
			return <PostCardAgentTeam {...props} />;
		case 'discussion':
			return <PostCardDiscussion {...props} />;
		default: {
			const _exhaustive: never = post.abilityType;
			return null;
		}
	}
}
